import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "@/components/layout/ProtectedRoute";
import RedirectRestore from "@/components/layout/RedirectRestore";
import AdminPage from "@/pages/AdminPage";
import ChatPage from "@/pages/ChatPage";
import LinkPage from "@/pages/LinkPage";
import LoginPage from "@/pages/LoginPage";
import UnauthorizedPage from "@/pages/UnauthorizedPage";
import WidgetPage from "@/pages/WidgetPage";

export default function App() {
  return (
    <BrowserRouter>
      <RedirectRestore />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route path="/widget/:widgetId" element={<WidgetPage />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminPage />
            </ProtectedRoute>
          }
        />
        {/* Las aprobaciones viven en la home (sidebar conmuta a la bandeja).
            /approvals se mantiene como redirect para no romper enlaces antiguos. */}
        <Route path="/approvals" element={<Navigate to="/?view=approvals" replace />} />
        <Route
          path="/link/:widgetId"
          element={
            <ProtectedRoute>
              <LinkPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <ChatPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
